module.exports = __webpack_public_path__ + "img/p3.bd243299.png";